import "./usercontentheader.scss";

interface IUserContentHeader {
    title: string
    subtitle?: string
    icon?: JSX.Element
    iconColor?: string
    box: JSX.Element
}

const UserContentHeader = ({title, subtitle, icon, iconColor, box}: IUserContentHeader) => {
    return (
        <div className="User-Content-Header">
            <div className="User-Content-Header-Title-Container">
                <span className="User-Content-Header-Title-Container-Text">{title}</span>
                <div className="User-Content-Header-Title-Container-Icon" style={{fill: iconColor}}>
                    {icon}
                </div>
                <p className="User-Content-Header-Title-Container-SubText">{subtitle}</p>
            </div>
            <div className="User-Content-Header-Box-Container">
                {box}
            </div>
        </div>
    )
}

export default UserContentHeader